import { useHistory, useLocation } from 'react-router-dom';
import { track } from 'shared/Tracking';
import { PostJobLocationState } from './formTypes';

export function usePostJobNavigation() {
    const history = useHistory();
    const location = useLocation();
    const from = `${location.pathname}${location.search}`;

    const goToPostJob = (source: string, presets: Omit<PostJobLocationState, 'from'> = {}) => {
        track('Opened post job page', { location: source });
        history.push('/jobs/post', { ...presets, from });
    };

    const goToDraft = (source: string, draftId: number) => {
        track('Opened post job page', { location: source, draftId });
        history.push(`/jobs/post?draft=${draftId}`, { from });
    };

    return { goToPostJob, goToDraft };
}
